import React from 'react';
import { formatPeriod, PlanPeriod } from '../../../../utils';

interface MonthSwitcherProps {
  period: PlanPeriod;
  isCurrent: boolean;
  disabled?: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
}

const MonthSwitcher: React.FC<MonthSwitcherProps> = ({ period, isCurrent, disabled = false, onPrevious, onNext, onToday }) => (
  <div className="monthly-plan-switcher">
    <button
      type="button"
      className="btn btn-secondary monthly-plan-switcher-arrow"
      onClick={onPrevious}
      disabled={disabled}
      title="Попередній місяць"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>

    <div className="monthly-plan-switcher-center">
      <span className="monthly-plan-switcher-title">{formatPeriod(period)}</span>
      {isCurrent ? (
        <span className="monthly-plan-switcher-hint">Поточний місяць</span>
      ) : (
        <button type="button" className="budget-ai-link-btn" onClick={onToday} disabled={disabled}>
          До поточного місяця
        </button>
      )}
    </div>

    <button
      type="button"
      className="btn btn-secondary monthly-plan-switcher-arrow"
      onClick={onNext}
      disabled={disabled}
      title="Наступний місяць"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </button>
  </div>
);

export default MonthSwitcher;
